import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'src/index';
import {
  MoreProfileOptionsMenuRef,
  MoreProfileOptionsMenuContainerProps,
} from './MoreProfileOptionsMenu.types';
import { MoreProfileOptionsMenu } from './MoreProfileOptionsMenu.component';

const MoreProfileOptionsMenuContainer = React.forwardRef<
  MoreProfileOptionsMenuRef,
  MoreProfileOptionsMenuContainerProps
>(({ profileUserUID, ...otherProps }, ref) => {
  // Global state
  const authUserUID = useSelector<RootState, string | null>(
    (state) => state.auth.id,
  );

  // Flag indicating whether the profile's user is the current user
  const isOwn = authUserUID === profileUserUID;

  return <MoreProfileOptionsMenu ref={ref} isOwn={isOwn} {...otherProps} />;
});

export { MoreProfileOptionsMenuContainer as MoreProfileOptionsMenu };
